<template>
    <div class="editContent">
        <div class="tableBox">
            <header>修改信息</header>
            <div class="closeBtn el-icon-error" @click="closeFn"></div>
            <div class="formBox">
                <el-form :inline="true" label-position="right" label-width="100px">
                <el-form-item v-for="(parentItem,index) in tableList" :key="index" :label="parentItem.name">
                    <el-select class="widthSelect" v-model="parentItem.value" multiple 
                    :popper-append-to-body='false'
                    :placeholder="parentItem.placeholder"
                    :loading="loadingFlag"
                    @change="getChangeContent($event,parentItem.key)"
                    @visible-change="tableListSelect($event,parentItem.indexPinyin,index)">
                    <el-option
                        v-for="item in parentItem.list"
                        :key="item.id"
                        :label="item.dictCont"
                        :value="item.dictCont">
                        </el-option>
                    </el-select>
                    
                </el-form-item>
               
                <div>
                    <el-form-item  label="安装角度" style="width: 300px" class="angle">
                        <el-select placeholder="角度调节" style="width: 110px"
                        :popper-append-to-body='false'
                        v-model="installationAngle[0].value"
                        @change="getChangeContent($event,installationAngle[0].key)"
                        @visible-change="angleSelect($event,installationAngle[0].indexPinyin,0)">
                            <el-option
                                v-for="item in installationAngle[0].list"
                                :key="item.id"
                                :label="item.dictCont"
                                :value="item.dictCont">
                                </el-option>
                        </el-select>
                        <el-input style="width: 45%;font-size:12px;" 
                        v-if="installationAngle[0].value == '可调节'"
                        @input="getChangeContent($event,'exaInstallAngleValue')" placeholder="" v-model="installationAngle[0].valueMsg"></el-input>
                    </el-form-item>
                    <el-form-item label="表面温度" class="width202">
                        <el-input placeholder="" 
                        @change="getChangeContent($event,'surfaceTemperature')"
                         v-model="surfaceTemperature"  style="300px"></el-input>
                    </el-form-item>  
                    <el-form-item label="重量Kg"  class="width202">
                        <el-input placeholder="" v-model="weight"
                        @change="getChangeContent($event,'weight')"
                        style="300px"></el-input>
                    </el-form-item> 
                </div>
                        
                <div>
                    <el-form-item label="安装支架">
                        <el-select v-model="bracket[0].value" multiple :placeholder="bracket[0].placeholder"
                        @visible-change="bracketSelect($event,bracket[0].indexPinyin,0)"
                        @change="getChangeContent($event,bracket[0].key)"
                        :popper-append-to-body='false'
                        :loading="loadingFlag">
                        <el-option
                            v-for="item in bracket[0].list"
                            :key="item.id"
                            :label="item.dictCont"
                            :value="item.dictCont">
                            </el-option>
                        </el-select>
                        <el-select v-model="bracket[1].value" multiple :placeholder="bracket[1].placeholder"
                        @visible-change="bracketSelect($event,bracket[1].indexPinyin,1)"
                        @change="getChangeContent($event,bracket[1].key)"
                        :popper-append-to-body='false'
                        :loading="loadingFlag">
                        <el-option
                            v-for="item in bracket[1].list"
                            :key="item.id"
                            :label="item.dictCont"
                            :value="item.dictCont">
                            </el-option>
                        </el-select>
                        <el-select v-model="bracket[2].value" multiple :placeholder="bracket[2].placeholder"
                        @visible-change="bracketSelect($event,bracket[2].indexPinyin,2)"
                        @change="getChangeContent($event,bracket[2].key)"
                        :popper-append-to-body='false'
                        :loading="loadingFlag">
                        <el-option
                            v-for="item in bracket[2].list"
                            :key="item.id"
                            :label="item.dictCont"
                            :value="item.dictCont">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                     
                </el-form >  
                <el-form label-width="100px">
                    <div>
                        <el-form-item label="标签内容：">
                            <el-input style="width: 98%"
                            @input="getChangeContent($event,'labelContent')"
                             v-model="labelContent"></el-input>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item label="特点/优势：">
                            <el-input style="width:98%"
                            @input="getChangeContent($event,'exaAdvantage')"
                            v-model="exaAdvantage"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            
              <div class="btnBox">
                  <el-row type="flex" justify="center" >
                    <el-button type="primary"  round @click="changeMsg">修改信息</el-button>
                    <el-button type="info" round @click="closeFn">取消修改</el-button>
                </el-row>
              </div>
              
        </div>
    </div>
</template>

<script>
export default {
    props:['tableInfo'],
    data(){
        return{
            changeFlag:false,//是否修改过
            changeData:{
                id:'',
                storageId:'',
            },
            // 标签内容
            labelContent:'',
            // 特点优势
            exaAdvantage:'',
            //重量
            weight:'',
            // 表面温度
            surfaceTemperature:'',
            valueKey:['exaColorTempe','exaLength','exaPower','exaIpLevel','exaControl','exaControlSub','exaAttachment','surfaceQuality','lampQuality'],
            loadingFlag:true,
            labelList:['caijichuxianfangxiang','caijidengtiyanse'],
            //安装角度
            installationAngle:[
                {
                    placeholder:'安装角度',
                    indexPinyin:'caijianzhuangjiaodudiaojie',
                    key:'exaInstallAngle',
                    list:[],
                    value:[],
                    valueMsg:''
                }
                
            ],
            // 安装支架
            bracketValueKey:['exaInstallSupportType','exaInstallSupport','exaInstallSupportPosition'],
            bracket:[
                {
                    placeholder:'支架类型',
                    indexPinyin:'caijianzhuangzhijialeixing',
                    key:'exaInstallSupportType',
                    list:[],
                    value:[]
                },
                {
                    placeholder:'支架高度',
                    indexPinyin:'caijianzhuangzhijiagaodu',
                    key:'exaInstallSupport',
                    list:[],
                    value:[]
                },
                {
                    placeholder:'支架位置',
                    indexPinyin:'caijianzhuangzhijiaweizhi',
                    key:'exaInstallSupportPosition',
                    list:[],
                    value:[]
                },
            ],
            tableList:[
                // 色温
                {
                    name:'色温',
                    placeholder:'色温',
                    indexPinyin:'caijisewen',
                    key:'exaColorTempe',
                    list:[
                    ],
                    value:[]
                },
                // 长度
                {
                    name:'长度',
                    placeholder:'长度',
                    indexPinyin:'caijizhangdu',
                    key:'exaLength',
                    list:[],
                    value:[]
                },
                // 电压
                {
                    name:'电压',
                    placeholder:'电压',
                    indexPinyin:'gongzuodianya',
                    key:'exaPower',
                    list:[],
                    value:[]
                },
                // IP等级
                {
                    name:'IP等级',
                    placeholder:'IP等级',
                    indexPinyin:'caijiIP',
                    key:'exaIpLevel',
                    list:[],
                    value:[]
                },
                // 控制
                {
                    name:'控制',
                    placeholder:'控制',
                    indexPinyin:'kongzhixieyi',
                    key:'exaControl',
                    list:[],
                    value:[]
                },
                // 分段控制:
                {
                    name:'分段控制',
                    placeholder:'分段控制',
                    indexPinyin:'kongzhixieyierji',
                    key:'exaControlSub',
                    list:[],
                    value:[]
                },
                // 可配附件
                {
                    name:'可配附件',
                    placeholder:'可配附件',
                    indexPinyin:'caijikepeifujian',
                    key:'exaAttachment',
                    list:[],
                    value:[]
                },
                // 表面材质:
                {
                    name:'表面材质',
                    placeholder:'表面材质',
                    indexPinyin:'caijibiaomiancaizhi',
                    key:'surfaceQuality',
                    list:[],
                    value:[]
                },
                // 灯体材质:
                {
                    name:'灯体材质',
                    placeholder:'灯体材质',
                    indexPinyin:'caijidengticaizhi',
                    key:'lampQuality',
                    list:[],
                    value:[]
                }
            ],
            
        }
    },
    mounted(){
        for(let i=0;i<this.tableList.length;i++){
            this.tableList[i].value = this.valueArr(this.tableInfo[this.valueKey[i]])
        }
        for(let i=0;i<this.bracketValueKey.length;i++){
            this.bracket[i].value = this.valueArr(this.tableInfo[this.bracketValueKey[i]])
        }
        this.installationAngle[0].value = this.valueArr(this.tableInfo.exaInstallAngle)
        this.installationAngle[0].valueMsg = this.valueArr(this.tableInfo.exaInstallAngleValue)
        this.weight = this.tableInfo.weight;//重量
        this.exaAdvantage = this.tableInfo.exaAdvantage;//特点优势
        this.labelContent = this.tableInfo.labelContent;//标签内容
        this.surfaceTemperature = this.tableInfo.surfaceTemperature;//表面温度
        this.changeData.storageId = this.tableInfo.storageId;
        this.changeData.id = this.tableInfo.id;  
    },
    methods:{
        // 修改信息事件
        changeMsg(){
            if(this.changeFlag){
                this.$http.putObj("/api/contestStorageExa/update", this.changeData, (res)=> {
                    if (res.success) {
                        this.$message({
                            message: "修改成功！",
                            type: "success"
                        });
                        this.$emit('changeAfter',1);
                        this.closeFn()
                        this.changeFlag = false;
                    }else{
                        this.$message.error(res.data)
                    }
                });
            }else{
                this.$message({
                    message: "请至少修改一项",
                    type: "error"
                });
            }
        },
        // 更改
        getChangeContent(data,key){
            this.changeFlag = true;
            this.changeData[key] = data.toString();
        },
        valueArr(data){
            if(data == '') return;
            return data.split(',')
        },
        //关闭遮罩
        closeFn(){
            this.$emit("childrenClose")
        },
        //表单选择
        tableListSelect(flag,name,index){
            if(flag){
                this.selectChange('tableList',name,index)
            }
        },
        angleSelect(flag,name,index){
            if(flag){
                this.selectChange('installationAngle',name,index)
            }
        },
        //表单选择
        bracketSelect(flag,name,index){
            if(flag){
                this.selectChange('bracket',name,index)
            }
        },
        selectChange(table,name,index){
            this.$http.get("/api/dictTypeAllList", {indexPinyin:name}, (res)=> {
                this[table][index].list = res.data;
                this.loadingFlag = false;
            });
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss">
    .editContent{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.3);
        .tableBox{
            width: 60%;
            height: 68%;
            background: #fff;
            position: absolute;
            top: 11%;
            left: 20%;
            padding: 20px;
            padding-top: 0;
            border-radius: 10px;
            header{
                text-align: center;
                font-size: 25px;
                line-height: 80px;
            }
            .closeBtn{
                position: absolute;
                top: 10px;
                right: 15px;
                font-size: 30px;
            }
            .widthSelect{
                width: 200px;
            }
        }
    }
    .btnBox{
        width: 100%;
        position: absolute;
        bottom: 20px;
    }
    .angle .el-form-item__content{
        width: 200px;
    }
    .width202 .el-input__inner{
        width: 202px;
    }
    .formBox{
        height: 76%;
        overflow-y: scroll;
    }
</style>